import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { Clock, MailCheck, LogOut } from "lucide-react";

export default function UnderReview() {
  const { user, logout } = useAuth();
  const unverified = user?.account_state === "email_verification_pending" || user?.email_verified === false;
  const declined = user?.account_state === "declined";

  return (
    <div className="min-h-screen flex flex-col text-white"
      style={{ background: "radial-gradient(1100px 520px at 20% -10%, #0090D6 0%, transparent 55%), linear-gradient(160deg,#013A5A 0%,#006090 60%,#00527D 100%)" }}>
      <header className="h-16 flex items-center justify-between px-6 border-b border-white/10">
        <Logo theme="dark" size={26} />
        <Button variant="ghost" onClick={logout} data-testid="under-review-signout" className="text-white hover:bg-white/10">
          <LogOut className="w-4 h-4 mr-1.5" /> Sign Out
        </Button>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-lg w-full bg-white/5 border border-white/15 rounded-2xl p-10 text-center backdrop-blur" data-testid="under-review-card">
          <span className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mx-auto mb-5">
            {unverified ? <MailCheck className="w-7 h-7 text-brand-cyan" /> : <Clock className="w-7 h-7 text-brand-cyan" />}
          </span>
          {unverified ? (
            <>
              <h1 className="font-display text-2xl font-bold">Please verify your email</h1>
              <p className="mt-3 text-white/75 text-sm leading-relaxed" data-testid="under-review-message">
                We've sent a verification link to <strong>{user?.email}</strong>. Verify your email so our
                recruiting team can review your area. You'll get access once verified and approved.
              </p>            </>
          ) : declined ? (
            <>
              <h1 className="font-display text-2xl font-bold">Thank you for your interest</h1>
              <p className="mt-3 text-white/75 text-sm leading-relaxed">
                Our recruiting team has reviewed your registration. If you have questions, please reach out to our team.
              </p>
            </>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold">Your account is under review</h1>
              <p className="mt-3 text-white/75 text-sm leading-relaxed" data-testid="under-review-message">
                Your account has been verified and is being reviewed by our recruiting team.
                We'll let you know when access is available.
              </p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
